import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Tabs, Tab } from "@mui/material";

export const VideoLibrary = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const activeTab = location.pathname.startsWith("/video-library/plans") ? "plans" : "exercises";

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
      <h1 style={{ margin: "0 0 12px 0" }}>{t("videoLibrary.title")}</h1>
      <Tabs
        value={activeTab}
        onChange={(_, value) => navigate(value === "plans" ? "/video-library/plans" : "/video-library")}
        sx={{ mb: 2, flexShrink: 0, minHeight: 36 }}
      >
        <Tab value="exercises" label={t("videoLibrary.exercisesTab")} sx={{ minHeight: 36 }} />
        <Tab value="plans" label={t("videoLibrary.plansTab")} sx={{ minHeight: 36 }} />
      </Tabs>
      <Outlet />
    </div>
  );
};
